var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('div',{staticClass:"flex-grow-1"},[_c('RouterView',{staticClass:"h-100",on:{"selected":function($event){_vm.page = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }